import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DigitalmarketService {

    constructor(private http: HttpClient) { }

    getdigimarkService() {
        return this.http.get<any[]>(`${environment.apiUrl}digital-marketing`);
    }    	    
}
